"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
* Created on Tue Jul 17 2018
*/

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * The outlier detection is used to “remove” the extremely suspicious values meaning low or
 * high competitors’ prices collected by external agencies (or detected in web scraping).
 *  The outlier prices are not deleted but only tagged with outlier flag.
 * @author RV
 */


var OutlierPriceDetectionSettings =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(OutlierPriceDetectionSettings, _DomainObject_1$Domai);

  /**
   * Constructs OutlierPriceDetectionSettings instance.
   *
   * @param outlierHistoryLength maximal history length of competitor data (product, price) for outlier detection (in days)
   * @param outlierLimit If it is detected more than x % outlier prices, then display the alert to user and tag all these
   * prices as regular. User can set the thresholds/limit x % for outlier (“outlier limit”).
   */
  function OutlierPriceDetectionSettings(outlierHistoryLength, outlierLimit) {
    var _this;

    _classCallCheck(this, OutlierPriceDetectionSettings);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(OutlierPriceDetectionSettings).call(this));
    _this.outlierHistoryLength = outlierHistoryLength;
    _this.outlierLimit = outlierLimit;
    return _this;
  }

  return OutlierPriceDetectionSettings;
}(DomainObject_1.DomainObject);

exports.OutlierPriceDetectionSettings = OutlierPriceDetectionSettings; // tslint:disable-next-line:member-ordering

OutlierPriceDetectionSettings.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(OutlierPriceDetectionSettings.name);
  return {
    outlierHistoryLength: builder.num('outlierHistoryLength'),
    outlierLimit: builder.num('outlierLimit')
  };
}();